import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LimitDialogComponent } from './components/limit-dialog/limit-dialog.component';
import { LegacyDialogComponent, LegacyDialogData, LegacyDialogEnum } from './components/legacy-dialog/legacy-dialog.component';
import { ConfirmDialogComponent, ConfirmDialogData } from './components/confirm-dialog/confirm-dialog.component';
import { ClipboardDialogComponent, ClipboardDialogData } from './components/clipboard-dialog/clipboard-dialog.component';
import { ScreenDimensions } from '../shared/models/screen.dimensions.model';
import { DialogIds } from './models/dialog-ids';
import { EngineService } from '../engine/engine.service';
import { EventsEnum } from '../engine/models/events.enum';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';

const mobileScreenWidth = 959;
@Injectable({
  providedIn: 'root'
})
export class DialogService {

  get isMobile(): boolean {    
    return window.innerWidth <= mobileScreenWidth;
  }

  constructor(
    private dialog: MatDialog,
    private engineService: EngineService
  ) { }

  openClipboardDialog(copyText: string, config?: MatDialogConfig<ClipboardDialogData>) {
    const options = {      
      data: {
        id: DialogIds.ClipboardDialog,
        copyText: copyText
      },
      ...config
    };

    return this.dialog.open(ClipboardDialogComponent, options);
  }
  
  openConfirmDialog(config?: MatDialogConfig<ConfirmDialogData>) {
    const options = {
      id: DialogIds.ConfirmDialog,
      ...config
    };

    return this.dialog.open(ConfirmDialogComponent, options);
  }

  openLimitDialog() {
    this.closeAllDialogs();

    return this.dialog.open(LimitDialogComponent, {
      id: DialogIds.LimitDialog,
      width: '480px'
    });
  }

  openUpgradeDialog(config?: MatDialogConfig<LegacyDialogData>) {
    const dimensions: ScreenDimensions = {
      width: 925,
      height: 700
    };
    const options = {
      id: DialogIds.UpgradeDialog,
      ...{
        width: `${dimensions.width}px`,
        height: `${dimensions.height}px`,
        data: <LegacyDialogData>{
          type: LegacyDialogEnum.UpgradeSubscription,
          dimensions: dimensions
        }
      },
      ...config
    };

    this.closeAllDialogs();

    if (environment.native) {
      this.engineService.fireEvent(EventsEnum.NativeUpgrade, null);
      return of();
    } else {
      return this.dialog.open(LegacyDialogComponent, options)
        .afterClosed();
    }
  }

  openPremiumContentDialog() {
    const upgradeEnabled = environment.native || !this.isMobile;

    const bodyText = upgradeEnabled
      ? 'This is premium content. Upgrade to a Premium Plan for unlimited access.'
      : 'This is premium content. Visit us on desktop to upgrade to a premium plan.';

    return this.openConfirmDialog({
      id: DialogIds.PremiumContentDialog,
      data: {
        titleText: 'Premium Content',
        bodyText: bodyText,
        confirmText: 'Go Premium',
        confirmEnabled: upgradeEnabled,
        cancelText: 'OK',
        confirmColor: 'warn'
      }
    });
  }

  closeAllDialogs() {
    this.dialog.closeAll();
  }

  
}
